import React, { useState } from "react";
import { toast } from "sonner";
import { FilePdf } from "@phosphor-icons/react";
import api from "@/lib/api";

// Saves a printable PDF of this guide (with its screenshots).
export function DownloadPdfButton({ slug }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/help/articles/${slug}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${slug}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch {
      toast.error("Couldn't make the PDF. Try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={download} disabled={busy} data-testid="help-article-download-pdf"
            className="inline-flex items-center gap-1.5 border-2 border-black bg-amber-300 px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest transition-colors duration-100 hover:bg-black hover:text-white disabled:opacity-50">
      <FilePdf size={14} weight="bold" /> {busy ? "Making PDF…" : "Download PDF"}
    </button>
  );
}
